module.exports = __webpack_public_path__ + "img/cartotrade-logo.b7a99a76.png";